module.exports = __webpack_public_path__ + "img/trending.43d48a23.svg";